const AVATAR_COLORS = [
  '4f46e5',
  '7c3aed',
  'db2777',
  'dc2626',
  'ea580c',
  'd97706',
  '65a30d',
  '0d9488',
  '0284c7',
  '6366f1',
];

const buildAvatarInitials = (name = '', username = '') => {
  const source =
    String(name || '').trim() || String(username || '').trim() || '?';
  const parts = source.split(/\s+/).filter(Boolean);

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0]?.[0] || ''}${parts[1]?.[0] || ''}`.toUpperCase() || '?';
};

const buildAvatarDataUrl = (name = '', username = '') => {
  const initials = buildAvatarInitials(name, username);
  const hash = [...`${name || ''}${username || ''}`].reduce(
    (accumulator, character) => accumulator + character.charCodeAt(0),
    0
  );
  const backgroundColor = AVATAR_COLORS[hash % AVATAR_COLORS.length];
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128"><rect width="128" height="128" fill="#${backgroundColor}"/><text x="64" y="64" dominant-baseline="central" text-anchor="middle" fill="white" font-family="sans-serif" font-size="48" font-weight="600">${initials}</text></svg>`;

  return `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(svg))
  )}`;
};

const normalizeAvatarSrc = (src) => {
  if (typeof src !== 'string') return null;

  const normalized = src.trim();
  if (!normalized) return null;
  if (normalized === 'null' || normalized === 'undefined') return null;

  return normalized;
};

export { buildAvatarInitials, buildAvatarDataUrl, normalizeAvatarSrc };
